import { Box, Drawer, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { handlerDrawerOpen, useGetMenuMaster } from '~/api/menu';
import { DRAWER_WIDTH } from '~/config';

import DrawerContent from './DrawerContent';
import { DrawerHeader } from './DrawerHeader';
import MiniDrawerStyled from './MiniDrawerStyled';

interface Props {
  window?: () => Window;
  externalBannerOffset?: number;
}

const MainDrawer = ({ window, externalBannerOffset = 0 }: Props) => {
  const theme = useTheme();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1200 }} aria-label="mailbox folders">
      {!matchDownMD ? (
        <MiniDrawerStyled
          variant="permanent"
          open={drawerOpen}
          externalBannerOffset={externalBannerOffset}
        >
          <DrawerHeader isOpen={drawerOpen} />
          <DrawerContent />
        </MiniDrawerStyled>
      ) : (
        <Drawer
          container={container}
          variant="temporary"
          open={drawerOpen}
          onClose={() => handlerDrawerOpen(!drawerOpen)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: DRAWER_WIDTH,
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundImage: 'none',
              boxShadow: 'inherit',
              ...(externalBannerOffset > 0 && {
                top: externalBannerOffset,
                height: `calc(100% - ${externalBannerOffset}px)`,
              }),
            },
          }}
        >
          <DrawerHeader isOpen={drawerOpen} />
          <DrawerContent />
        </Drawer>
      )}
    </Box>
  );
};

export default MainDrawer;
